import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const ErrorAlert = styled(Box)(({ theme }) => ({
  width: "450px",
  height: "86px",
  borderRadius: "6px",
  boxShadow: "0 4px 10px 0 rgba(0, 0, 0, 0.08)",
  border: "solid 1px #efefef",
  backgroundColor: "#ffffff",
  display: "flex",
  color: "#373737",
  transition: "all 0.4s ease",
  "@media (max-width: 500px)": {
    width: "auto"
  }
}));

export const IconContainer = styled(Box)(({ theme }) => ({
  width: "86px",
  height: "85px",
  flex: "0 0 86px",
  backgroundColor: "#000",
  borderTopLeftRadius: "6px",
  borderBottomLeftRadius: "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& svg": {
    width: "24px",
    stroke: "#fff",
    fill: "#fff"
  }
}));

export const ErrorMessage = styled(Box)(({ theme }) => ({
  paddingLeft: "17px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  flex: 1,
  paddingRight: 45,
  overflow: "hidden"
}));

export const ErrorReason = styled("h6")(({ theme }) => ({
  margin: "0 0 3px 0",
  fontSize: "14px",
  fontWeight: "600"
}));

export const ErrorDescription = styled("p")(({ theme }) => ({
  margin: "0",
  fontSize: "12px",
  lineHeight: 1.33,
  color: "#86868b"
}));

export const CloseIconWrapper = styled(Box)(({ theme }) => ({
  flex: "0 0 auto",
  padding: "23px 20px 0 0",
  display: "flex",
  alignItems: "flex-start"
}));

export const StyledCloseIcon = styled(Box)(({ theme }) => ({
  width: 24,
  cursor: "pointer"
}));
